// LoginForm.js

import React, { useState } from 'react';
import axios from 'axios';
import "../../tps.css"

const platformID = localStorage.getItem('platformID'); // Get platformID from local storage

const LoginForm = () => {
  const [formData, setFormData] = useState({
    UserName: '',
    Password: ''
  });
  const [error, setError] = useState('');
  const API = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(`${API}/api/author/login`, formData);

      // alert(response.data.message);
      // Store token if needed
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('AuthorID', response.data.AuthorID);
      localStorage.setItem('UserName', formData.UserName);
      //store platformId if needed
      // localStorage.setItem('platformId', response.data.platformId); // Assuming the response contains platformId
      // Redirect to dashboard here if needed
      //alert paltformId

      window.location.href = '/author/dashboard'; // Redirect to the author's dashboard
    } catch (error) {
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data.message === 'You are authenticated but not approved. Please contact the host.'
      ) {
        setError(error.response.data.message);
      } else {
        setError(error.response.data.message || 'Invalid credentials');
      }
    }
  };

  // //  Forgot Password Handler
  const handleForgotPassword = async () => {
    const email = window.prompt('Enter your registered email to receive a password reset link:');
    if (!email) return;

    try {
      const response = await axios.post(`${API}/api/author/forgot-password`, { email });
      alert('Password reset link has been sent to your registered email.');
    } catch (err) {
      alert(
        err.response?.data?.message || 'Failed to send reset link. Please try again later.'
      );
    }
  };

  return (
    <div className="container mt-5 d-flex justify-content-center ml-2">
      <div className="card p-4" style={{ width: '100%', maxWidth: '420px' }}>
        {/* <h5 className="text-muted text-end mb-1">Platform ID: <strong>{platformID}</strong></h5> */}

        <h3 className=" mb-4 page-title">Author Login</h3>
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="UserName" className="form-label fw-semibold">User Name</label>
            <input
              type="text"
              name="UserName"
              id="UserName"
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group mb-3">
            <label htmlFor="Password" className="form-label fw-semibold">Password</label>
            <input
              type="password"
              name="Password"
              id="Password"
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-100 mt-2">Login</button>
        </form>

        {/*  Forgot Password link */}
        <div className="text-center mt-3">
          <button
            className="btn btn-link text-decoration-none p-0"
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </button>
        </div>

      </div>
    </div>
  );
};

export default LoginForm;
